/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TimezoneMetadata } from './TimezoneMetadata';
import {
    TimezoneMetadataFromJSON,
    TimezoneMetadataFromJSONTyped,
    TimezoneMetadataToJSON,
    TimezoneMetadataToJSONTyped,
} from './TimezoneMetadata';

/**
 * Response containing security level initialization information
 * @export
 * @interface SecurityLevelInitializationResponse
 */
export interface SecurityLevelInitializationResponse {
    /**
     * 
     * @type {string}
     * @memberof SecurityLevelInitializationResponse
     */
    userTimezone?: string;
    /**
     * Indicates if the request was successful
     * @type {boolean}
     * @memberof SecurityLevelInitializationResponse
     */
    success?: boolean;
    /**
     * Error message if the request failed
     * @type {string}
     * @memberof SecurityLevelInitializationResponse
     */
    error?: string;
    /**
     * 
     * @type {TimezoneMetadata}
     * @memberof SecurityLevelInitializationResponse
     */
    timezoneMetadata?: TimezoneMetadata;
    /**
     * Number of security levels initialized
     * @type {number}
     * @memberof SecurityLevelInitializationResponse
     */
    levelsInitialized?: number;
}

/**
 * Check if a given object implements the SecurityLevelInitializationResponse interface.
 */
export function instanceOfSecurityLevelInitializationResponse(value: object): value is SecurityLevelInitializationResponse {
    return true;
}

export function SecurityLevelInitializationResponseFromJSON(json: any): SecurityLevelInitializationResponse {
    return SecurityLevelInitializationResponseFromJSONTyped(json, false);
}

export function SecurityLevelInitializationResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SecurityLevelInitializationResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'userTimezone': json['userTimezone'] == null ? undefined : json['userTimezone'],
        'success': json['success'] == null ? undefined : json['success'],
        'error': json['error'] == null ? undefined : json['error'],
        'timezoneMetadata': json['timezone_metadata'] == null ? undefined : TimezoneMetadataFromJSON(json['timezone_metadata']),
        'levelsInitialized': json['levelsInitialized'] == null ? undefined : json['levelsInitialized'],
    };
}

export function SecurityLevelInitializationResponseToJSON(json: any): SecurityLevelInitializationResponse {
    return SecurityLevelInitializationResponseToJSONTyped(json, false);
}

export function SecurityLevelInitializationResponseToJSONTyped(value?: SecurityLevelInitializationResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userTimezone': value['userTimezone'],
        'success': value['success'],
        'error': value['error'],
        'timezone_metadata': TimezoneMetadataToJSON(value['timezoneMetadata']),
        'levelsInitialized': value['levelsInitialized'],
    };
}

